import { twMerge } from "tailwind-merge";
import { SelectGroup, SelectOption } from "../control/types";
import Select, { SelectProps } from "../select/select";
import { useControlGroupSize } from "./context";
import { controlGroupControlStyles } from "./styles";

export default function ControlGroupSelect<
  Option extends SelectOption = SelectOption,
  IsMulti extends boolean = boolean,
  Group extends SelectGroup<Option> = SelectGroup<Option>,
>({
  className,
  size,
  ...props
}: Readonly<SelectProps<Option, IsMulti, Group>>) {
  const resolvedSize = useControlGroupSize(size);

  return (
    <Select<Option, IsMulti, Group>
      {...props}
      size={resolvedSize}
      className={twMerge(controlGroupControlStyles, className)}
    />
  );
}
